
export const GET_PRINT_ORDER_HASH_INFO = 'GET_PRINT_ORDER_HASH_INFO';
export const GET_INFO_PRINT_ORDER = 'GET_INFO_PRINT_ORDER';